module.exports = __webpack_public_path__ + "img/Microphone Icon - white.fe8b02ba.svg";